import DialogHeaderTemplate from './dialog-header.component.html'

export const DialogHeaderComponent = {
    transclude: true,
    bindings: {
        class: '@pfClass',
    },
    template: DialogHeaderTemplate,
};
